import {
    FETCH_INVITATIONS,
    FETCH_INVITATIONS_FAILURE,
    FETCH_INVITATIONS_SUCCESS,
} from 'store/actions/types';

export const fetchInvitations = (payload) => {
    return {
        type: FETCH_INVITATIONS,
        payload: payload,
    };
};

export const fetchInvitationsFailure = (error) => {
    return {
        type: FETCH_INVITATIONS_FAILURE,
        payload: error,
    };
};

export const fetchInvitationsSuccess = (response) => {
    return {
        type: FETCH_INVITATIONS_SUCCESS,
        payload: response,
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/accounts/invitations/fetchInvitations.js